import { OfferDetailsProps } from './offer-details';
import { ITranslate, INumberToStringFormatter } from 'locale';
import { isNil } from 'lodash';
import { DealType } from 'utils/entities';


enum OfferDetailsType {
  BedsCount = 'bedsCount',
  Floor = 'floor',
  Area = 'area',
  PricePerSize = 'pricePerSize',
}

const RESIDENTIAL_OFFER_DETAILS = [
  OfferDetailsType.BedsCount,
  OfferDetailsType.Floor,
  OfferDetailsType.Area,
];

const COMMERCIAL_OFFER_DETAILS = [
  OfferDetailsType.Area,
  OfferDetailsType.PricePerSize,
  OfferDetailsType.Floor,
];


interface OfferMeta {
  beds: number;
  floor: number | string;
  floors: number | string;
  area: number;
  pricePerSizeUnit: number;
  t: ITranslate;
  formatMoney: INumberToStringFormatter;
  formatArea: INumberToStringFormatter;
  isCommercial: boolean;
  withBackDivider: boolean;
  dealType: string;
}

export function createOfferTypesByMarketPlace(isCommercial: boolean): OfferDetailsType[] {
  return isCommercial ? COMMERCIAL_OFFER_DETAILS : RESIDENTIAL_OFFER_DETAILS;
}

export function createOfferProps(type: OfferDetailsType, meta: OfferMeta): OfferDetailsProps | null  {
  const {
    t,
    beds,
    area,
    floor,
    floors,
    dealType,
    formatArea,
    formatMoney,
    isCommercial,
    withBackDivider,
    pricePerSizeUnit,
  } = meta;

  switch (type) {
    case OfferDetailsType.BedsCount:
      return typeof beds === 'number' ? {
        locator: 'beds-count',
        value: beds.toString(),
        description: t('unitPage.offerType.description', { type }),
        withBackDivider,
      } : null;
    case OfferDetailsType.Floor:
      const useFloors = isCommercial && isNil(floor) && !isNil(floors);
      const value = useFloors ? floors : floor;
      return isNil(value) ? null : {
        locator: 'floor',
        value: t('filters.floorLabels', { floor: value }),
        description: t('unitPage.offerType.description', { type: useFloors ? 'floors' : type }),
        withBackDivider,
      };
    case OfferDetailsType.Area:
      return Boolean(area) && area > 0 ? {
        locator: 'area',
        description: t('unitPage.offerType.description', { type }),
        value: formatArea(area, false),
        withBackDivider,
      } : null;
    case OfferDetailsType.PricePerSize:
      return (pricePerSizeUnit > 0) && (dealType === DealType.Buy) ? {
        locator: 'pricePerSize',
        description: t('unitPage.offerType.description', { type }),
        value: formatMoney(pricePerSizeUnit),
        withBackDivider,
      } : null;
    default:
      return null;
  }
}
